<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="deleteChapterDialog"
    title="حذف الفصل"
    confirm-text="حذف"
    confirm-variant="danger"
    @confirm="handleConfirm"
  >
    <template #body>
      <p>هل أنت متأكد أنك تريد حذف الفصل <strong>{{ chapterName }}</strong>؟</p>
      <p class="text-danger">لا يمكن التراجع عن هذا الإجراء.</p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';

const baseDialog = ref(null);
const chapterName = ref('');
const chapterId = ref(null);

const open = (chapter) => {
  chapterName.value = chapter.name;
  chapterId.value = chapter.id;
  baseDialog.value?.openDialog();
};

const emit = defineEmits(['delete']);

const handleConfirm = () => {
  emit('delete', chapterId.value);
  baseDialog.value?.closeDialog();
};

defineExpose({ open });
</script>